<ion-app>
  <ion-router-outlet [swipeGesture]="swipe"></ion-router-outlet>
</ion-app>
